/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Membership_Confirmations_First_Invoice_DateInputs */

const en_admin_membership_confirmations_first_invoice_date = /** @type {(inputs: Admin_Membership_Confirmations_First_Invoice_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date of first recurring invoice`)
};

const nl_admin_membership_confirmations_first_invoice_date = /** @type {(inputs: Admin_Membership_Confirmations_First_Invoice_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum van eerste terugkerende factuur`)
};

/** @type {(inputs: Admin_Membership_Confirmations_First_Invoice_DateInputs) => LocalizedString} */
const de_admin_membership_confirmations_first_invoice_date = en_admin_membership_confirmations_first_invoice_date;

/** @type {(inputs: Admin_Membership_Confirmations_First_Invoice_DateInputs) => LocalizedString} */
const es_admin_membership_confirmations_first_invoice_date = en_admin_membership_confirmations_first_invoice_date;

/** @type {(inputs: Admin_Membership_Confirmations_First_Invoice_DateInputs) => LocalizedString} */
const fr_admin_membership_confirmations_first_invoice_date = en_admin_membership_confirmations_first_invoice_date;

/** @type {(inputs: Admin_Membership_Confirmations_First_Invoice_DateInputs) => LocalizedString} */
const it_admin_membership_confirmations_first_invoice_date = en_admin_membership_confirmations_first_invoice_date;

/** @type {(inputs: Admin_Membership_Confirmations_First_Invoice_DateInputs) => LocalizedString} */
const pt_br2_admin_membership_confirmations_first_invoice_date = en_admin_membership_confirmations_first_invoice_date;

/** @type {(inputs: Admin_Membership_Confirmations_First_Invoice_DateInputs) => LocalizedString} */
const pl_admin_membership_confirmations_first_invoice_date = en_admin_membership_confirmations_first_invoice_date;

/** @type {(inputs: Admin_Membership_Confirmations_First_Invoice_DateInputs) => LocalizedString} */
const hu_admin_membership_confirmations_first_invoice_date = en_admin_membership_confirmations_first_invoice_date;

/** @type {(inputs: Admin_Membership_Confirmations_First_Invoice_DateInputs) => LocalizedString} */
const ro_admin_membership_confirmations_first_invoice_date = en_admin_membership_confirmations_first_invoice_date;

/**
* | output |
* | --- |
* | "Date of first recurring invoice" |
*
* @param {Admin_Membership_Confirmations_First_Invoice_DateInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_membership_confirmations_first_invoice_date = /** @type {((inputs?: Admin_Membership_Confirmations_First_Invoice_DateInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Membership_Confirmations_First_Invoice_DateInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_membership_confirmations_first_invoice_date(inputs)
	if (locale === "de") return de_admin_membership_confirmations_first_invoice_date(inputs)
	if (locale === "es") return es_admin_membership_confirmations_first_invoice_date(inputs)
	if (locale === "fr") return fr_admin_membership_confirmations_first_invoice_date(inputs)
	if (locale === "nl") return nl_admin_membership_confirmations_first_invoice_date(inputs)
	if (locale === "it") return it_admin_membership_confirmations_first_invoice_date(inputs)
	if (locale === "pt-BR") return pt_br2_admin_membership_confirmations_first_invoice_date(inputs)
	if (locale === "pl") return pl_admin_membership_confirmations_first_invoice_date(inputs)
	if (locale === "hu") return hu_admin_membership_confirmations_first_invoice_date(inputs)
	return ro_admin_membership_confirmations_first_invoice_date(inputs)
});
export { admin_membership_confirmations_first_invoice_date as "admin.membership_confirmations.first_invoice_date" }